var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-agreement-container"},[_c('iframe',{staticClass:"agreement-iframe",attrs:{"src":_vm.agreementUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }